import { useNavigate } from 'react-router-dom';

import { CollectionComponentTypeForm } from '../components/CollectionComponentTypeForm';

export const CreateCollectionComponentTypePage = () => {
  const navigate = useNavigate();

  return (
    <div className="p-10">
      <div>
        <CollectionComponentTypeForm
          type="Create"
          onSubmit={async (collectionComponentTypeId) => {
            navigate(
              `/collection-components/new?typeId=${collectionComponentTypeId}`
            );
          }}
          onCancel={() => {
            navigate(`/collection-components/new`);
          }}
        />
      </div>
    </div>
  );
};
